import api from '../../api';

export const reportContentsStartRequest = () => {
  return {
    type: 'REPORT_CONTENTS_START_REQUEST'
  };
};

export const reportContentsEndRequest = () => {
  return {
    type: 'REPORT_CONTENTS_END_REQUEST'
  };
};

export const reportContentsSuccess = ({ data }, type) => {
  return {
    type: 'REPORT_CONTENTS_SUCCESS',
    payload: { data, type }
  };
};

export const reportContentsError = (error, type) => {
  return {
    type: 'REPORT_CONTENTS_ERROR',
    payload: { error, type }
  };
};

export const reportContentsDefault = type => {
  return {
    type: 'REPORT_CONTENTS_DEFAULT',
    payload: { type }
  };
};

const requestReportContents = (data, url, type, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(reportContentsStartRequest());
      const response = await api().post(url, data);
      dispatch(reportContentsSuccess(response, type));
    } catch (err) {
      dispatch(reportContentsError(err, type));
    } finally {
      setTimeout(() => {
        dispatch(reportContentsEndRequest());
        submitBtn.disabled = false;
        document.getElementsByClassName('page-content')[0].scrollTo({
          top: Number.MAX_SAFE_INTEGER,
          left: 0,
          behavior: 'smooth'
        });
      }, 500);
    }
  };
};

export const groupsReportContents = (data, submitBtn) => {
  return async dispatch => {
    const url = '/api/reports/groups';
    const type = 'groups';
    dispatch(requestReportContents(data, url, type, submitBtn));
  };
};

export const usersReportContents = (data, submitBtn) => {
  return async dispatch => {
    const url = '/api/reports/users';
    const type = 'users';
    dispatch(requestReportContents(data, url, type, submitBtn));
  };
};

export const eventsReportContents = (data, submitBtn) => {
  return async dispatch => {
    const url = '/api/reports/events';
    const type = 'events';
    dispatch(requestReportContents(data, url, type, submitBtn));
  };
};

export const recordingsReportContents = (data, submitBtn) => {
  return async dispatch => {
    const url = '/api/reports/recordings';
    const type = 'recordings';
    dispatch(requestReportContents(data, url, type, submitBtn));
  };
};
